import { css } from 'styled-components';
var getCardStyle = function getCardStyle() {
  return css([".c7n-card{div:nth-last-child(1):nth-child(1).c7n-card-body{padding:0.16rem;margin:0;}.c7n-card-body:empty{display:none;}&.c7n-card-only-title{.c7n-card-head-title{padding:0.16rem 0;}}}"]);
};
var cardData = {
  name: 'card',
  data: [{}],
  // 孔雀蓝原效果没有对该组件进行样式覆盖，只是在组件库基础上修改颜色变量
  onlyTemplate: {
    base: getCardStyle
  }
};
export default cardData;